import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useNavigate } from 'react-router-dom';
import { useAppWrapperContext } from 'ui/layouts/AppWrapper';
import useModal from 'ui/partials/Modal/useModal';
import { toastSuccess } from 'ui/partials/Toast';
import partialConstants from 'ui/partials/utils/constants';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';

import c from '../utils/constants';

export default function useDeleteCompany() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { hideModal } = useModal();
  const { accountId, accountUserId } = useAdminParams();
  const {
    state: { isPreview },
  } = useAppWrapperContext();
  const { state } = useProvider();
  const args = state;

  return useMutation({
    mutationFn: async ({ id }: Record<string, string>) => {
      const api = new Api(args);

      const data = await api.delete(
        await withAcl({
          account: {
            url: `api/v1/contacts/companies/${id}`,
          },
          admin: {
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/contacts/companies/${id}`,
          },
        }),
      );

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [c.COMPANIES, {}],
      });
      queryClient.invalidateQueries({
        queryKey: [partialConstants.TAGS],
      });

      toastSuccess('Successfully deleted company');

      navigate(
        isPreview
          ? `/accounts/${accountId}/users/${accountUserId}/contact/companies`
          : '/contact/companies',
      );
      hideModal();
    },
  });
}
